(ns ui.components.popover-filter.view
  (:require
   [clojure.edn :as edn]
   [common.localization :as loc]
   [common.util :as cu]
   [promesa.core :as p]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.popover.view :as popover]
   [ui.components.select.async-virtualized :as async-select]
   [ui.editors.data-input :as data-input]
   [ui.editors.labelled-input.view :as labelled-input]))

(defn buttons
  [{:keys [on-cancel on-save!]}]
  [:div
   {:class "mt-2 flex gap-2 "}
   [button/secondary-hollow
    {:on-click on-cancel}
    (loc/tr :cancel)]

   [button/primary-solid
    {:on-click on-save!}
    (loc/tr :save)]])

(defn date-input
  [{:keys [filter on-value-change] :as args}]
  [:div
   {:class "flex flex-col gap-2"}
   [data-input/view
    {:data-type (:filter/data-type filter)
     :value     (first (:filter/value filter))
     :on-change (fn [new-val]
                  (on-value-change [new-val nil]))}]])

(defn numeric-input
  [{:keys [filter on-value-change] :as args}]
  [:div
   {:class "flex flex-col gap-2"}
   [data-input/view
    {:data-type (:filter/data-type filter)
     :value     (first (:filter/value filter))
     :on-blur   (fn [new-val]
                  (on-value-change [new-val]))}]])

(defn string-input
  [{:keys [filter on-value-change] :as args}]
  [:div
   {:class "flex flex-col gap-2"}
   [data-input/view
    {:data-type (:filter/data-type filter)
     :value     (first (:filter/value filter))
     :on-change (fn [new-val]
                  (on-value-change [new-val]))}]])
(defn numeric-range
  [{:keys [filter on-value-change] :as args}]
  (let [[from-val to-val] (:filter/value filter)]
    [:div
     {:class "flex flex-col gap-2"}
     [data-input/view
      {:data-type (:filter/data-type filter)
       :value     (first (:filter/value filter))
       :on-blur   (fn [new-val]
                    (on-value-change [new-val to-val]))}]
     [:span
      (loc/tr :and)]
     [data-input/view
      {:data-type (:filter/data-type filter)
       :value     (second (:filter/value filter))
       :on-blur   (fn [new-val]
                    (on-value-change [from-val new-val]))}]]))

(defn date-range
  [{:keys [filter on-value-change] :as args}]
  (let [[from-value to-value] (:filter/value filter)]
    [:div
     {:class "flex flex-col gap-2"}
     [data-input/view
      {:data-type (:filter/data-type filter)
       :value     from-value
       :on-change (fn [new-val]
                    (on-value-change [new-val to-value]))}]
     [:span
      (loc/tr :and ["" ""])]
     [data-input/view
      {:data-type (:filter/data-type filter)
       :value     to-value
       :on-change (fn [new-val]
                    (on-value-change [from-value new-val]))}]]))

(defn resolve-value
  [local-atom filter option-value]
  (let [options (:filter/options filter)
        get-options (:filter/get-options filter)]
    (or (some->> options
                 (cu/filter-by :value option-value)
                 (first))
        (some->> @local-atom
                 :options
                 (cu/filter-by :value option-value)
                 (first))
        (when (fn? get-options)
          (let [get-options-response (get-options filter)]
            (if-let [options (:options get-options-response)]
              (->> options
                   (cu/filter-by :value option-value)
                   (first))
              (-> get-options-response
                  (p/then (fn [{:keys [options]}]
                            (swap! local-atom assoc :options options)))
                  (p/catch (fn [err]
                             (js/console.log "Resolve filter value error " err))))))))))

(defn async-select
  [{:keys [filter on-value-change local-atom] :as args}]
  (let [[filter-value _] (:filter/value filter)
        get-options (:filter/get-options filter)]
    [:div
     {:class "flex flex-col gap-2"}
     (when-let [selected-options (seq filter-value)]
       (->> selected-options
            (map (partial resolve-value local-atom filter))
            (map (fn [opt]
                   [:li
                    {:class "flex items-center gap-2"}
                    [data-input/view
                     {:editor-type :editor.type/checkbox
                      :value       true
                      :on-change   (fn [_]
                                     (on-value-change [(->> filter-value
                                                            (remove (fn [fv]
                                                                      (= fv (:value opt))))
                                                            (vec))]))}]
                    [:label
                     {:class "font-semibold"}
                     (:label opt)]]))
            (into
             [:ul
              {:class "flex flex-col gap-2"}
              ])))
     [async-select/view
      {:value       nil
       :get-options (fn [search-term callback-js]
                      (let [options (seq (:filter/options filter))]
                        (if (fn? get-options)
                          (get-options filter search-term callback-js)
                          (callback-js (->> options
                                            (map (fn [{:keys [value label] :as opt}]
                                                   (assoc opt :value (pr-str value)))))))))
       :on-change!  (fn [selected-value selected-option]
                      (let [value (:value selected-option)
                            new-value (if (fn? get-options)
                                        value
                                        (edn/read-string value))]
                        (let [new-value (vec (concat filter-value [new-value]))]
                          (on-value-change [new-value nil]))))
       :is-multi?   false}]]))

(defn quick-select
  [{:keys [filter on-value-change] :as args}]
  (let [{:keys [filter/value filter/options]} filter
        selected (first value)]
    [:div
     {:class "flex flex-col gap-2"}
     (into
      [:ul
       {:class "flex flex-col gap-2"}]
      (->> options
           (map (fn [opt]
                  (let [selected? (boolean (some #{(:value opt)} selected))]
                    [:li
                     {:class "flex items-center gap-2"}
                     [data-input/view
                      {:editor-type :editor.type/checkbox
                       :value       selected?
                       :on-change   (fn [_]
                                      (let [new-value (if selected?
                                                        (->> selected
                                                             (remove #(= % (:value opt)))
                                                             (vec))
                                                        (vec (conj selected (:value opt))))]
                                        (on-value-change [new-value])))}]
                     [:label
                      {:class "font-semibold"}
                      (:label opt)]])))
           (doall)))]))

(defn multi-value
  [{:keys [filter on-value-change local-atom] :as args}]
  (let [{:keys [filter/get-options filter/options]} filter
        option-count (count options)]
    (cond get-options
          [async-select args]
          (> option-count 10)
          [async-select args]
          (pos? option-count)
          [quick-select args]
          :else
          [:div "Error no options"])))

(defn value-input
  [{:keys [filter set-value!] :as args}]
  (case (:filter/data-type filter)
    :data.type/boolean nil
    :data.type/currency-symbol [multi-value args]
    :data.type/currency-value [numeric-input args]
    :data.type/date [date-input args]
    :data.type/datetime [date-input args]
    :data.type/email [string-input args]
    :data.type/email-multi [string-input args]
    :data.type/financials nil
    :data.type/id [string-input args]
    :data.type/integer [numeric-input args]
    :data.type/keyword [multi-value args]
    :data.type/keyword-multi [multi-value args]
    :data.type/long [numeric-input args]
    :data.type/multiplier [numeric-input args]
    :data.type/number [numeric-input args]
    :data.type/percentage [numeric-input args]
    :data.type/ref-multi [multi-value args]
    :data.type/ref-single [multi-value args]
    :data.type/tesi-financials nil
    :data.type/tesi-financials-2 nil
    :data.type/text [string-input args]
    :data.type/text-edn nil
    :data.type/text-multi [string-input args]
    :data.type/text-multiline [string-input args]
    :data.type/text-richtext [string-input args]
    :data.type/text-simple [string-input args]
    :data.type/text-url [string-input args]))

(defn value-block
  [{:keys [filter on-operator-change on-field-change field-options local-atom] :as args}]
  (let [{:keys [filter-label filter/operator filter-operator-options]} filter
        field-options (->> field-options
                           (map (fn [item]
                                  (assoc item :value (pr-str (:value item))))))
        filter-operator-options (->> filter-operator-options
                                     (map (fn [item]
                                            (assoc item :value (pr-str (:value item))))))]
    [:div
     {:class "flex flex-col gap-3"}
     [:div
      {:class "min-w-48"}
      [labelled-input/view
       {:data-type :data.type/keyword
        :options   field-options
        :value     (->> field-options
                        (cu/filter-by :value (pr-str (:filter/key-path filter)))
                        (first))
        :label     (loc/tr :field)
        :on-change (fn [option]
                     (let [option-value (edn/read-string option)]
                       (when (fn? on-field-change)
                         (on-field-change option-value))))}]]
     [labelled-input/view
      {:data-type :data.type/keyword
       :label     (loc/tr :condition)
       :options   filter-operator-options
       :value     (->> filter-operator-options
                       (cu/filter-by :value (pr-str operator))
                       (first))
       :on-change (fn [js-oper]
                    (let [oper (edn/read-string js-oper)]
                      (swap! local-atom assoc :filter/operator oper)
                      (on-operator-change oper)))}]

     (case (:filter/operator filter)
       :filter-operator/between-exclusive [numeric-range args]
       :filter-operator/between-inclusive [numeric-range args]
       :filter-operator/date-after [date-input args]
       :filter-operator/date-before [date-input args]
       :filter-operator/date-on-or-after [date-input args]
       :filter-operator/date-on-or-before [date-input args]
       :filter-operator/date-between [date-range args]
       :filter-operator/does-not-contain-exactly [string-input args]
       :filter-operator/ends-with [string-input args]
       :filter-operator/equal-or-greater-than [numeric-input args]
       :filter-operator/equal-or-smaller-than [numeric-input args]
       :filter-operator/equals [value-input args]
       :filter-operator/greater-than [numeric-input args]
       :filter-operator/is-known nil
       :filter-operator/is-unknown nil
       :filter-operator/is-true nil
       :filter-operator/is-false nil
       :filter-operator/matches-all-of [multi-value args]
       :filter-operator/matches-any-of [multi-value args]
       :filter-operator/matches-none-of [multi-value args]
       :filter-operator/not-equal [value-input args]
       :filter-operator/smaller-than [numeric-input args]
       :filter-operator/starts-with [string-input args]
       :filter-operator/text-contains [string-input args]
       :filter-operator/text-contains-ignore-case [string-input args]
       :filter-operator/text-equals [string-input args]
       :filter-operator/text-equals-ignore-case [string-input args]
       :filter-operator/text-does-not-contain [string-input args]
       :filter-operator/text-does-not-contain-ignore-case [string-input args]

       (js/console.error (str "Unknown filter " filter)))]))

(defn filter-pop-over
  [{:keys [on-save! filter on-delete! on-cancel] :as args}]
  [:div
   [value-block args]
   ;[buttons args]
   ])

(defn view
  [{:keys [trigger-button filter on-save! on-operator-change on-value-change start-open? on-field-change placeholder field-options as-child?]}]
  (let [local-atom (r/atom {:popup-open? start-open?})]
    (fn [{:keys [trigger-button filter on-save! on-delete! as-child?]}]
      [popover/view
       {:open?          (:popup-open? @local-atom)
        :on-open-change #(reset! local-atom {:popup-open? %})
        :as-child?      (boolean as-child?)}
       trigger-button
       [:div
        {:class "w-52"}
        [filter-pop-over
         {:on-cancel          #(reset! local-atom {})
          :field-options      field-options
          :filter             (merge filter
                                     @local-atom)
          :local-atom         local-atom
          :placeholder        placeholder
          :on-field-change    on-field-change
          :on-operator-change on-operator-change
          :on-value-change    on-value-change
          :on-delete!         (fn [filter]
                                (when (fn? on-delete!)
                                  (on-delete! filter))
                                (reset! local-atom {}))
          :on-save!           (fn [_]
                                (on-save! (merge filter
                                                 (when-let [oper (:filter/operator @local-atom)]
                                                   {:filter/operator oper})
                                                 (when-let [value (:filter/value @local-atom)]
                                                   {:filter/value value})))
                                (reset! local-atom {}))}]]])))
